export const stateChangeTracker = new WeakMap();
export function upsertStateChange(state, change) {
    const stateChange = stateChangeTracker.get(state);
    const updatedStateChange = Object.assign(Object.assign({}, stateChange), change);
    stateChangeTracker.set(state, updatedStateChange);
    return updatedStateChange;
}
export function transition(state, action, transitions) {
    var _a, _b;
    let newState = state;
    const stateChange = stateChangeTracker.get(state);
    // @ts-ignore
    if (transitions[state.state] && transitions[state.state][action.type]) {
        // @ts-ignore
        newState = transitions[state.state][action.type](state, action);
        (_a = stateChange === null || stateChange === void 0 ? void 0 : stateChange.debugDispatch) === null || _a === void 0 ? void 0 : _a.call(stateChange, action, false);
        upsertStateChange(newState, {
            action,
            prevState: state,
        });
        stateChangeTracker.delete(state);
    }
    else {
        (_b = stateChange === null || stateChange === void 0 ? void 0 : stateChange.debugDispatch) === null || _b === void 0 ? void 0 : _b.call(stateChange, action, true);
    }
    return newState;
}
export function match() {
    const state = arguments[0];
    const matches = arguments[1];
    const _ = arguments[2];
    if (_) {
        return (matches[state.state] || _)(state);
    }
    return matches[state.state](state);
}
export function matchProp() {
    const state = arguments[0];
    const prop = arguments[1];
    // @ts-ignore
    return prop in state ? state : undefined;
}
//# sourceMappingURL=utils.js.map